import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({
  loader: async () => {
    throw redirect({ to: '/fleet-management/vehicles' });
  },
});
